import React, { FC } from 'react';
import { Box, Button, Link, Typography } from '@mui/material';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const GUARDIAN_ORANGE = '#E06A10';
const GUARDIAN_ORANGE_LIGHT = '#FEF3EB';

export interface GuardianWelcomeStepProps {
  onContinue: () => void;
  onBack?: () => void;
}

const GuardianWelcomeStep: FC<GuardianWelcomeStepProps> = ({ onContinue, onBack }) => {
  return (
    <Box>
      {onBack && (
        <Link
          component="button"
          onClick={onBack}
          underline="none"
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'text.secondary',
            fontSize: 14,
            mb: 4,
            '&:hover': { color: 'text.primary' },
          }}
        >
          <ChevronLeftIcon sx={{ fontSize: 18, mr: 0.25 }} />
          Back
        </Link>
      )}

      {/* Shield icon */}
      <Box
        sx={{
          width: 52,
          height: 52,
          borderRadius: 3,
          backgroundColor: GUARDIAN_ORANGE_LIGHT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <ShieldOutlinedIcon sx={{ color: GUARDIAN_ORANGE, fontSize: 28 }} />
      </Box>

      <Typography variant="h5" fontWeight={700} mb={1.5}>
        Welcome,{' '}
        <Typography component="span" variant="h5" fontWeight={700} sx={{ color: GUARDIAN_ORANGE }}>
          Guardian!
        </Typography>
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={4} sx={{ lineHeight: 1.7, maxWidth: 380 }}>
        Link your account with your athlete to track their schedule, monitor training progress, and stay fully informed
        on all coach-athlete interactions — ensuring a safe and supportive environment.
      </Typography>

      <Button
        variant="contained"
        fullWidth
        onClick={onContinue}
        sx={{
          borderRadius: 999,
          py: 1.25,
          fontWeight: 600,
          fontSize: 15,
          backgroundColor: GUARDIAN_ORANGE,
          '&:hover': { backgroundColor: GUARDIAN_ORANGE, filter: 'brightness(0.9)' },
          boxShadow: 'none',
        }}
      >
        Continue
      </Button>
    </Box>
  );
};

export default GuardianWelcomeStep;
